module.exports = __webpack_public_path__ + "img/shutterstock_160644944@2x.3651410a.png";